export default "__VITE_ASSET__C61rJ87f__"